import { ReactNode, Suspense } from 'react';
import { PageWrapper } from '../Wrapper';
import LoaderCircle from '../Loading/circle/circle';
import { PageSkeleton } from '../Loading/PageSkeleton';
import { ListItemSkeleton } from '../Loading/ListItemSkeleton';
import { FormSkeleton } from '../Loading/FormSkeleton';

interface ILazyLoadComponent {
  Component: ReactNode;
  type?: 'PAGE' | 'LIST' | 'FORM';
}

export function LazyLoadComponent({
  Component,
  type = 'PAGE',
}: ILazyLoadComponent) {
  function fallback() {
    switch (type) {
      case 'FORM':
        return (
          <PageWrapper>
            <div className='[&>div]:bg-wl-background'>
              <FormSkeleton />
            </div>
          </PageWrapper>
        );
      case 'LIST':
        return (
          <PageWrapper>
            <div className='px-8 max-msm:px-4 sm:px-12 sm:my-8 my-4 [&>div]:bg-wl-background'>
              <ListItemSkeleton />
            </div>
          </PageWrapper>
        );

      default:
        return <PageSkeleton />;
    }
  }
  return (
    <Suspense fallback={<LoaderCircle size='large' />}>
      {/* <Skeleton active paragraph={{ rows: 10 }} avatar />

      <Skeleton active paragraph={{ rows: 10 }} round title />

      <PageSkeleton />

      <ListItemSkeleton />

      <PageSkeleton /> */}

      {Component}
    </Suspense>
  );
}
